import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import { Helmet } from "react-helmet";
import MicrosoftClarity from "../components/MicrosoftClarity";
import WhatsAppButton from "../components/WhatsAppButton";
import LandingChatbot from "../components/LandingChatbot";
import SocialButtons from "../components/SocialButton";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./AudienciaLanding.css";
import "./recuadro.css";
import useFacebookPixel from "../hooks/useFacebookPixel";

const AudienciaLanding = () => {
  const { usuario } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showQuestion, setShowQuestion] = useState(false);
  const [showReplayButton, setShowReplayButton] = useState(false);
  const [played, setPlayed] = useState(0);
  const [modal, setModal] = useState(true);
  const [surveyCompleted, setSurveyCompleted] = useState(false);
  const [showWhatsappLanding, setShowWhatsappLanding] = useState(false);
  const [encuesta, setEncuesta] = useState(null);
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    telefono: "",
  });
  const [errorForm, setErrorForm] = useState(false);
  const playerRef = useRef(null);

  const { trackContact, trackViewContent, CompleteRegistration, trackLead } = useFacebookPixel(usuario, {
    creadorId: data?.admin_id,
    campana: data?.nombre_campana,
    red: "facebook",
  });

  // Función para extraer texto sin HTML (para meta tags)
  const getTextFromHTML = (html) => {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        console.log("Buscando campaña para usuario:", usuario);
        const response = await axios.get(
          `https://api.mrcirp.com/public/campanas-audiencia/enlace/${usuario}`
        );
        
        console.log("Respuesta del API:", response.data);
        
        if (response.data && response.data.length > 0) {
          console.log("Campaña encontrada:", response.data[0]);
          setData(response.data[0]);
        } else {
          console.log("No se encontró la campaña");
          setError("Campaña no encontrada");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        console.error("Error response:", error.response);
        setError("Error al cargar la campaña: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchEncuesta = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/encuestacampana/${usuario}`
        );
        if (response.data && response.data.length > 0) {
          setEncuesta(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching encuesta:", error);
      }
    };

    if (usuario) {
      fetchData();
      fetchEncuesta();
    }
  }, [usuario]);

  const handleProgress = (state) => {
    if (!playerRef.current.seeking) {
      setPlayed(state.played);
    } else {
      playerRef.current.seekTo(played);
    }
  };

  const handleEnded = () => {
    setShowQuestion(true);
    setShowReplayButton(true);
  };

  const handleReplay = () => {
    setShowQuestion(false);
    setShowReplayButton(false);
    setPlayed(0);
    if (playerRef.current) {
      playerRef.current.seekTo(0);
    }
  };

  const handleOptionA = () => {
    if (data && data.urlBotonProducto) {
      window.location.href = data.urlBotonProducto;
    }
  };

  const handleOptionB = () => {
    if (data && data.urlBotonNegocio) {
      window.location.href = data.urlBotonNegocio;
    }
  };

  const handleOptionC = () => {
    window.location.href = "/";
  };

  const handleBack = () => {
    setShowQuestion(false);
    setShowReplayButton(false);
    if (playerRef.current) {
      playerRef.current.seekTo(0);
    }
  };

  const handleSurveyResponse = (response) => {
    setSurveyCompleted(true);
    if (response === "interested") {
      trackViewContent();
    }
  };

  const handleNextToWhatsapp = () => {
    setShowWhatsappLanding(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, telefono: value });
  };

  // Función para insertar contacto en Brevo (por campaña)
  const insertContactToBrevo = async (creadorId, nombreCampana) => {
    try {
      console.log('Intentando insertar contacto en Brevo para creador:', creadorId);
      console.log('Campaña:', nombreCampana);
      
      // 1) Intentar obtener Brevo relacionado a la campaña
      let cred = null;
      try {
        if (nombreCampana && String(nombreCampana).trim()) {
          const lista = await axios.get(`https://api.mrcirp.com/public/brevocampanas/${creadorId}`);
          const match = (lista.data || []).find(
            (r) =>
              String(r?.campana || "").trim().toLowerCase() ===
              String(nombreCampana).trim().toLowerCase()
          );
          if (match?.api_key) cred = match;
        }
      } catch (e) {
        // Si falla, usamos fallback GLOBAL
      }

      // 2) Fallback a Brevo GLOBAL del creador
      if (!cred) {
        const brevoResponse = await axios.get(`https://api.mrcirp.com/public/brevo/${creadorId}`);
        if (brevoResponse.data && brevoResponse.data[0] && brevoResponse.data[0].api_key) {
          cred = brevoResponse.data[0];
        }
      }

      console.log('Respuesta de credenciales Brevo:', cred);

      if (cred && cred.api_key) {
        const { user_id, api_key } = cred;

        // Preparar datos del contacto (igual que en el formulario de prueba)
        const contactData = {
          email: formData.correo.trim(),
          updateEnabled: false
        };

        // Agregar nombre y apellido si está presente (dividir el nombre completo)
        if (formData.nombre && formData.nombre.trim()) {
          const nombreParts = formData.nombre.trim().split(' ');
          contactData.attributes = {};
          if (nombreParts.length > 0) {
            contactData.attributes.NOMBRE = nombreParts[0];
          }
          if (nombreParts.length > 1) {
            contactData.attributes.APELLIDO = nombreParts.slice(1).join(' ');
          }
        }

        // Agregar teléfono si está presente
        if (formData.telefono) {
          if (!contactData.attributes) {
            contactData.attributes = {};
          }
          // PhoneInput con international devuelve formato E.164 (ej: +51987654321)
          // Brevo acepta formato con código de país: +91xxxxxxxxxx o 0091xxxxxxxxxx
          // Usar el valor tal cual viene de PhoneInput (ya tiene el formato correcto)
          contactData.attributes.SMS = formData.telefono.trim();
        }

        // Agregar ID de lista si está configurado
        if (user_id && user_id.trim()) {
          const listId = parseInt(user_id.trim());
          if (!isNaN(listId)) {
            contactData.listIds = [listId];
          }
        }

        console.log('=== DATOS A ENVIAR A BREVO ===');
        console.log('URL:', 'https://api.brevo.com/v3/contacts');
        console.log('Headers:', {
          'accept': 'application/json',
          'content-type': 'application/json',
          'api-key': api_key.trim().substring(0, 20) + '...' // Solo mostrar primeros caracteres por seguridad
        });
        console.log('Body completo:', JSON.stringify(contactData, null, 2));

        // Insertar contacto en Brevo
        const response = await axios({
          method: 'POST',
          url: 'https://api.brevo.com/v3/contacts',
          headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'api-key': api_key.trim()
          },
          data: contactData
        });

        console.log('=== RESPUESTA EXITOSA DE BREVO ===');
        console.log('Status:', response.status);
        console.log('Status Text:', response.statusText);
        console.log('Headers:', response.headers);
        console.log('Data:', JSON.stringify(response.data, null, 2));
      } else {
        console.log('No se encontraron credenciales de Brevo para el usuario');
      }
    } catch (err) {
      // No mostrar error al usuario si falla Brevo, solo loguear
      console.error('=== ERROR AL INSERTAR CONTACTO EN BREVO ===');
      console.error('Error completo:', err);
      console.error('Error message:', err.message);
      console.error('Error code:', err.code);
      
      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Status Text:', err.response.statusText);
        console.error('Headers:', err.response.headers);
        console.error('Data (error completo):', JSON.stringify(err.response.data, null, 2));
        console.error('Request URL:', err.config?.url);
        console.error('Request method:', err.config?.method);
        console.error('Request data:', JSON.stringify(err.config?.data, null, 2));
      } else if (err.request) {
        console.error('Request enviado pero sin respuesta:', err.request);
      } else {
        console.error('Error al configurar la petición:', err.message);
      }
    }
  };

  const peticionPost = async () => {
    // Obtener el creador/admin_id y correo de la campaña
    const creadorId = data?.creador || data?.admin_id || null;
    
    // Obtener el correo del creador/admin (igual que en landing de video)
    let correoDestinario = '';
    if (creadorId) {
      try {
        const userResponse = await axios.get(`https://api.mrcirp.com/public/infousuario/${creadorId}`);
        if (userResponse.data && userResponse.data[0]) {
          correoDestinario = userResponse.data[0].correo || '';
        }
      } catch (errUser) {
        console.error('Error al obtener correo del usuario:', errUser);
      }
    }
    
    // Preparar datos en el mismo formato que el landing de video
    const nuevoLeadConUsuario = {
      nombre: formData.nombre,
      correo: formData.correo,
      telefono: formData.telefono,
      iduser: creadorId,
      usuario: usuario,
      correodestinario: correoDestinario
    };

    // Mostrar los datos que se van a enviar
    console.log("Datos a enviar:", nuevoLeadConUsuario);

    try {
      // Primera petición - Guardar lead (igual que landing de video)
      console.log("Enviando datos a leadsnuevos...");
      const res1 = await axios.post(
        "https://api.mrcirp.com/public/leadsnuevos",
        nuevoLeadConUsuario,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Respuesta de leadsnuevos:", res1.data);

      // Segunda petición - Enviar correo (igual que landing de video)
      console.log("Enviando datos a enviarcorreoleads...");
      const res2 = await axios.post(
        "https://api.mrcirp.com/enviarcorreoleads.php",
        nuevoLeadConUsuario,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Respuesta de enviarcorreoleads:", res2.data);

      // Insertar contacto en Brevo si el creador tiene Brevo configurado (por campaña)
      if (creadorId) {
        await insertContactToBrevo(creadorId, data?.nombre_campana);
      }

      trackContact();
      CompleteRegistration();
      setErrorForm(false);
      setModal(false);
    } catch (err) {
      console.error("Error submitting form:", err);
      setErrorForm(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.correo || !formData.telefono) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    peticionPost();
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando campaña...</p>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="error-container">
        <div className="error-content">
          <h1>404 - Campaña no encontrada</h1>
          <p>La campaña que buscas no existe o ha sido eliminada.</p>
          <a href="/" className="btn-home">Volver al inicio</a>
        </div>
      </div>
    );
  }

  // Parsear servicios_items si es un string JSON
  let serviciosItems = [];
  if (data.servicios_items) {
    try {
      serviciosItems = typeof data.servicios_items === 'string' 
        ? JSON.parse(data.servicios_items) 
        : data.servicios_items;
    } catch (e) {
      console.error('Error parsing servicios_items:', e);
    }
  }

  // Si se debe mostrar el landing de WhatsApp, renderizarlo
  if (showWhatsappLanding && data.whatsapp_titulo) {
    return (
      <div className="audiencia-landing">
        <Helmet>
          <title>{data.nombre_campana} - WhatsApp</title>
          <meta name="description" content={getTextFromHTML(data.whatsapp_subtitulo)} />
        </Helmet>

        {/* Landing de WhatsApp */}
        <section 
          className="banner-section"
          style={{
            backgroundImage: data.whatsapp_imagen_url ? `url(${data.whatsapp_imagen_url})` : 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px 24px'
          }}
        >
          <div className="container">
            <div className="banner-content" style={{ textAlign: 'center', zIndex: 1, position: 'relative' }}>
              <h1 
                className="banner-title" 
                style={{ 
                  color: 'white', 
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                  marginBottom: '16px'
                }}
                dangerouslySetInnerHTML={{ __html: data.whatsapp_titulo || 'Bienvenido' }}
              />
              <p 
                className="banner-subtitle" 
                style={{ 
                  color: 'white', 
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                  marginBottom: '24px'
                }}
                dangerouslySetInnerHTML={{ __html: data.whatsapp_subtitulo || 'Descubre lo que tenemos para ti' }}
              />
              
              {/* Video del WhatsApp Landing */}
              {data.whatsapp_video_url && (
                <div className="video-container" style={{ marginTop: '24px', width: '100%', maxWidth: '900px', height: '506px', margin: '0 auto 24px' }}>
                  <ReactPlayer
                    url={data.whatsapp_video_url}
                    width="100%"
                    height="100%"
                    controls={true}
                    className="banner-video"
                  />
                </div>
              )}

              {/* Botón de WhatsApp */}
              {data.whatsapp_boton_url && (
                <a 
                  href={data.whatsapp_boton_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    background: '#25D366',
                    color: 'white',
                    padding: '12px 32px',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    marginTop: '16px',
                    transition: 'background 0.3s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#128C7E'}
                  onMouseLeave={(e) => e.target.style.background = '#25D366'}
                >
                  Unete a Whatsapp
                </a>
              )}
            </div>
          </div>
        </section>

        <MicrosoftClarity />
        <WhatsAppButton />
        <LandingChatbot />
        {/* Botones Sociales - Solo si hay al menos un enlace social */}
        {(data?.facebook || data?.instagram || data?.linkedin || data?.tiktok || data?.calendly || data?.pdf) && (
          <SocialButtons
            pdfUrl={data?.pdf || undefined}
            facebookUrl={data?.facebook || undefined}
            instagramUrl={data?.instagram || undefined}
            linkedinUrl={data?.linkedin || undefined}
            tiktokUrl={data?.tiktok || undefined}
            calendlyUrl={data?.calendly || undefined}
            onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="audiencia-landing">
      <Helmet>
        <title>{data.nombre_campana}</title>
        <meta name="description" content={getTextFromHTML(data.descripcion)} />
        <meta property="og:title" content={data.nombre_campana} />
        <meta property="og:description" content={getTextFromHTML(data.descripcion)} />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Modal inicial */}
      {modal && (
        <Modal isOpen={modal} centered>
          <ModalHeader style={{ position: "relative", borderBottom: "none" }}>
            <div
              style={{
                position: "absolute",
                right: "20px",
                top: "15px",
                cursor: "pointer",
                zIndex: 1,
                fontSize: "24px",
                fontWeight: "bold"
              }}
              onClick={() => setModal(false)}
            >
              ×
            </div>
            {data.texto_modal && data.texto_modal.trim() !== '' ? (
              <h6 style={{ textAlign: "center", paddingRight: "30px", width: "100%", margin: 0 }}>
                {getTextFromHTML(data.texto_modal)}
              </h6>
            ) : (
              <div style={{ textAlign: "center", paddingRight: "30px", width: "100%", minHeight: "24px" }}>
                {/* Título vacío - solo para mantener el espacio */}
              </div>
            )}
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="nombre">Nombre</Label>
                <Input
                  type="text"
                  name="nombre"
                  id="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="correo">Correo Electrónico</Label>
                <Input
                  type="email"
                  name="correo"
                  id="correo"
                  value={formData.correo}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="telefono">Teléfono</Label>
                <PhoneInput
                  international
                  defaultCountry="PE"
                  value={formData.telefono}
                  onChange={handlePhoneChange}
                  placeholder="Ingresa tu número de teléfono"
                />
              </FormGroup>
              {errorForm && (
                <div style={{ color: 'red', marginBottom: '10px' }}>
                  Error al enviar el formulario. Por favor, intenta de nuevo.
                </div>
              )}
              <Button type="submit" color="primary" style={{ width: "100%" }}>
                Enviar
              </Button>
            </Form>
          </ModalBody>
        </Modal>
      )}

      {/* Banner Principal */}
      <section 
        className="banner-section"
        style={{
          backgroundImage: data.banner_imagen_url ? `url(${data.banner_imagen_url})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="container">
          <div className="banner-content" style={{ display: 'flex', flexDirection: showQuestion ? 'column' : 'column', gap: '20px', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: showQuestion ? 'row' : 'column', gap: '20px', width: '100%', alignItems: 'center' }}>
            <div style={{ flex: showQuestion ? '1' : '1', width: '100%' }}>
              <h1 
                className="banner-title" 
                style={{ color: 'white', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
                dangerouslySetInnerHTML={{ __html: data.banner_titulo || 'Bienvenido' }}
              />
              <p 
                className="banner-subtitle" 
                style={{ color: 'white', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}
                dangerouslySetInnerHTML={{ __html: data.banner_subtitulo || 'Descubre lo que tenemos para ti' }}
              />
              
              {/* Video del Banner */}
              {data.banner_video_url && (
                <div className="video-container" style={{ marginTop: '24px', width: '100%', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
                  {!showReplayButton ? (
                    <ReactPlayer
                      ref={playerRef}
                      url={data.banner_video_url}
                      width="100%"
                      height="100%"
                      controls={false}
                      playing={true}
                      onProgress={handleProgress}
                      onEnded={handleEnded}
                      className="banner-video"
                    />
                  ) : (
                    <div style={{ 
                      background: 'rgba(0,0,0,0.7)', 
                      padding: '40px', 
                      borderRadius: '10px', 
                      textAlign: 'center',
                      color: 'white'
                    }}>
                      <p style={{ marginBottom: '20px', fontSize: '18px' }}>Video finalizado</p>
                      <button 
                        onClick={handleReplay}
                        style={{
                          background: '#1890ff',
                          color: 'white',
                          border: 'none',
                          padding: '12px 24px',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '16px'
                        }}
                      >
                        Reproducir nuevamente
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* Imagen del Banner */}
              {data.banner_imagen_url && !data.banner_video_url && (
                <div className="image-container">
                  <img 
                    src={data.banner_imagen_url} 
                    alt={data.banner_titulo}
                    className="banner-image"
                  />
                </div>
              )}

              {/* Mensaje de agradecimiento y botón siguiente */}
              {surveyCompleted && (
                <div className="recuadro" style={{
                  marginTop: '20px',
                  padding: '24px',
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  width: '100%',
                  maxWidth: '600px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}>
                  <div style={{ padding: '20px', textAlign: 'center', color: '#333' }}>
                    <h4>¡Gracias por tu respuesta!</h4>
                    <p>Valoramos mucho tu opinión.</p>
                  </div>
                  <button
                    onClick={handleNextToWhatsapp}
                    style={{
                      padding: '12px 24px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      backgroundColor: '#25D366',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      transition: 'background-color 0.3s',
                      marginTop: '15px'
                    }}
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </div>

            {/* Cuestionario cuando termina el video - mostrar encuesta si existe */}
            {showQuestion && (
              <div style={{ flex: '1', width: '100%' }}>
                {encuesta && !surveyCompleted ? (
                  <div className="recuadro" style={{
                    padding: '24px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0'
                  }}>
                    <h4 style={{ color: '#333', marginBottom: '24px', fontSize: '20px', fontWeight: '600' }}>
                      {encuesta.pregunta}
                    </h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {encuesta.respuesta_1 && (
                        <button 
                          style={{
                            padding: '12px 20px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            backgroundColor: '#1890ff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            width: '100%',
                            transition: 'background-color 0.3s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#40a9ff'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#1890ff'}
                          onClick={() => {
                            if (encuesta.evento_1 === "cliente potencial") {
                              trackLead();
                            }
                            setSurveyCompleted(true);
                          }}
                        >
                          {encuesta.respuesta_1}
                        </button>
                      )}
                      {encuesta.respuesta_2 && (
                        <button 
                          style={{
                            padding: '12px 20px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            backgroundColor: '#1890ff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            width: '100%',
                            transition: 'background-color 0.3s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#40a9ff'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#1890ff'}
                          onClick={() => {
                            if (encuesta.evento_2 === "cliente potencial") {
                              trackLead();
                            }
                            setSurveyCompleted(true);
                          }}
                        >
                          {encuesta.respuesta_2}
                        </button>
                      )}
                      {encuesta.respuesta_3 && (
                        <button 
                          style={{
                            padding: '12px 20px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            backgroundColor: '#1890ff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            width: '100%',
                            transition: 'background-color 0.3s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#40a9ff'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#1890ff'}
                          onClick={() => {
                            if (encuesta.evento_3 === "cliente potencial") {
                              trackLead();
                            }
                            setSurveyCompleted(true);
                          }}
                        >
                          {encuesta.respuesta_3}
                        </button>
                      )}
                      <button 
                        style={{
                          padding: '12px 20px',
                          fontSize: '16px',
                          cursor: 'pointer',
                          backgroundColor: '#666',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          width: '100%',
                          marginTop: '10px'
                        }}
                        onClick={handleBack}
                      >
                        VOLVER
                      </button>
                    </div>
                  </div>
                ) : encuesta && surveyCompleted ? (
                  <div className="recuadro" style={{
                    padding: '24px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    textAlign: 'center'
                  }}>
                    <div style={{ padding: '20px', textAlign: 'center', color: '#333' }}>
                      <h4>¡Gracias por tu respuesta!</h4>
                      <p>Valoramos mucho tu opinión.</p>
                    </div>
                    <button
                      onClick={handleNextToWhatsapp}
                      style={{
                        padding: '12px 24px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        backgroundColor: '#25D366',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        transition: 'background-color 0.3s',
                        marginTop: '15px'
                      }}
                    >
                      Siguiente
                    </button>
                  </div>
                ) : null}
              </div>
            )}
            </div>

            {/* Botón para continuar - abarca ambas columnas */}
            {showQuestion && (
              <button
                onClick={handleNextToWhatsapp}
                style={{
                  width: '100%',
                  padding: '16px 32px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  backgroundColor: '#25D366',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  transition: 'background-color 0.3s',
                  marginTop: '20px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#128C7E'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#25D366'}
              >
                {data.banner_boton_finalizar || 'Haz click para continuar'}
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Sección de Servicios - Solo mostrar si no se ha presionado siguiente */}
      {!showWhatsappLanding && data.servicios_titulo && (
        <section 
          className="servicios-section"
          style={{
            backgroundImage: data.servicios_fondo_imagen ? `url(${data.servicios_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="section-header">
              <h2 
                className="section-title"
                dangerouslySetInnerHTML={{ __html: data.servicios_titulo || '' }}
              />
              <p 
                className="section-description"
                dangerouslySetInnerHTML={{ __html: data.servicios_descripcion || '' }}
              />
            </div>
            
            {serviciosItems.length > 0 && (
              <div className="servicios-grid">
                {serviciosItems.map((item, index) => (
                  <div key={index} className="servicio-card">
                    <h3 
                      className="servicio-title"
                      dangerouslySetInnerHTML={{ __html: item.titulo || '' }}
                    />
                    <p 
                      className="servicio-description"
                      dangerouslySetInnerHTML={{ __html: item.descripcion || '' }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Izquierda) - Solo mostrar si no se ha presionado siguiente */}
      {!showWhatsappLanding && data.dos_columnas_titulo && (
        <section 
          className="dos-columnas-section"
          style={{
            backgroundImage: data.dos_columnas_fondo_imagen ? `url(${data.dos_columnas_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-left">
                {data.dos_columnas_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.dos_columnas_imagen} 
                      alt={data.dos_columnas_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_titulo || '' }}
                />
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_descripcion || '' }}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Derecha) - Solo mostrar si no se ha presionado siguiente */}
      {!showWhatsappLanding && data.dos_columnas_derecha_titulo && (
        <section 
          className="dos-columnas-section reverse"
          style={{
            backgroundImage: data.dos_columnas_derecha_fondo_imagen ? `url(${data.dos_columnas_derecha_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_derecha_titulo || '' }}
                />
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_derecha_descripcion || '' }}
                />
              </div>
              <div className="column-left">
                {data.dos_columnas_derecha_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.dos_columnas_derecha_imagen} 
                      alt={data.dos_columnas_derecha_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer - Solo mostrar si no se ha presionado siguiente */}
      {!showWhatsappLanding && (
        <footer className="landing-footer">
          <div className="container">
            <div className="footer-content">
              <p className="footer-text">
                © 2024 KATANA - Constructor de Ingresos Residuales Perpetuos
              </p>
            </div>
          </div>
        </footer>
      )}

      {/* Botones de Usuario */}
      <WhatsAppButton
        phoneNumber={data?.whatsapp || ""}
        message="Hola, me gustaría obtener más información sobre esta campaña."
      />
      
      <LandingChatbot />
      
      {/* Botones Sociales - Ocultos en el landing de bienvenida, solo se muestran en el landing de WhatsApp */}
    </div>
  );
};

export default AudienciaLanding;
